// extracted by mini-css-extract-plugin
module.exports = {"LogpointsPane":"LogpointsPane_LogpointsPane__payLQ","List":"LogpointsPane_List__nGEd_","Empty":"LogpointsPane_Empty__fltvy"};